import { PressKitData } from "../types/componentsConstructors";

export const isPressKitEmpty = (data: PressKitData): boolean => {
  return Object.keys(data).length === 0;
};
